import React, { useState, useEffect  } from 'react'
import logo from '../../images/logo2.png';
import Fade from 'react-reveal/Fade';

const Logo = () =>  {

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

        
  if(isDesktop){
    return (
        <div>
            
            <Fade right={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
                    <img src={logo} alt="logo" className="float-left"/>
            </Fade>
        </div>
    )
  }
  else{
    return (
        <div>
            <Fade left={isDesktop} top={isMobile} duration={1000} delay={500} distance="30px">
                <img src={logo} alt="logo"/>
            </Fade>
        </div>
    )
  }
    
}

export default Logo;